import { ArgoCDAnnotationKeys } from "@octopusdeploy/octopus-server-client";
import type { ConfiguredSources } from "./ConfiguredSource";
export function createAnnotation(configuredSources: ConfiguredSources, isMultiSourceApplication: boolean): string {
    const annotations: Partial<Record<string, string | undefined>>[] = Object.values(configuredSources).map(({ source, projectSlug, environmentSlug, tenantSlug, helmExpression }) => {
        return {
            [ArgoCDAnnotationKeys.OctopusProjectAnnotationKey(source.Name)]: projectSlug,
            [ArgoCDAnnotationKeys.OctopusEnvironmentAnnotationKey(source.Name)]: environmentSlug,
            [ArgoCDAnnotationKeys.OctopusTenantAnnotationKey(source.Name)]: tenantSlug,
            [ArgoCDAnnotationKeys.OctopusImageReplacementPathsKey(source.Name)]: helmExpression,
        };
    });
    let annotation = `metadata:
  annotations:`;
    for (const dict of annotations) {
        for (const [key, value] of Object.entries(dict)) {
            if (value) {
                annotation += `\n    ${key}: "${value}"`;
            }
        }
    }
    return annotation;
}
